const Endpoint = {
    LOAD_COMPONENT_TREE: '/viiu/component-muting/load-component-tree',
};
export default Endpoint;
